import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';

export default (config) => {
    return async (payload) => {
        //? for debug: console.log(UpdateEmail:', payload);

        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const jwtFromCookie = getCookieByName(appCookieKey);
        const sharedCookie = getCookieByName(sharedCookieKey);
        if (jwtFromCookie && sharedCookie) {
            const wholeTokenFromCookie = JSON.parse(sharedCookie);

            let spatFromCookie = wholeTokenFromCookie.spat;

            if (spatFromCookie && jwtFromCookie) {
                let checkResult = await apiClient(config).apiMethod({
                    method: 'UpdateEmail',
                    headers: {
                        'X-Auth-Token': jwtFromCookie,
                        'X-Auth-Spat': spatFromCookie,
                    },
                    args: {
                        email: payload.email,
                        old_password: payload.old_password,
                    },
                });

                if (checkResult.code) {
                    return {
                        success: false,
                        errors: checkResult.code,
                    };
                } else if (checkResult) {
                    return {
                        payload: checkResult,
                        success: true,
                        errors: 'success',
                    };
                } else {
                    return {
                        success: false,
                        errors: ' _UNKNOWN',
                    };
                }
            } else {
                return {
                    success: false,
                    errors: ' _AUTHENTICATION',
                };
            }
        } else {
            return {
                success: false,
                errors: ' _AUTHENTICATION',
            };
        }
    };
};
